<script setup lang="ts">
import { useRouter } from "vue-router";
import type { HandlungBausteinProps, DeeplinkData } from "@/api/handlungen/types.ts";
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElAlert } from 'element-plus';
import { captureException } from '@sentry/vue';
import { ref } from 'vue';

type LinkFactoryFunction = ( data: DeeplinkData ) => string

const props = defineProps<HandlungBausteinProps<DeeplinkData>>();

const linkFactoryHasError = ref<boolean>(false);
const linkFactoryMap: Record<string, LinkFactoryFunction> = {
  checkup: ( _data: DeeplinkData ) => '/check-up'
} as const

function makeRoute (): { path: string } {
  const linkFactoryMapFunction = linkFactoryMap[props.baustein.data.section];
  if (linkFactoryMapFunction) {
    return { path: linkFactoryMapFunction(props.baustein.data) }
  }
  captureException(new Error(`No link factory function for section ${props.baustein.data.section}, or wrong section name`))
  linkFactoryHasError.value = true;
  return { path: '/meine-vertraege' };
}

const router = useRouter()
if (props.baustein.data.redirectAutomatically) {
  router.push( makeRoute() )
}

function onClick () {
  router.push( makeRoute())
}

</script>

<template>
  <div>
    <AppButton
      v-if="!linkFactoryHasError"
      type="primary"
      text
      bg
      class="my-3 mr-auto"
      @click="onClick"
    >
      {{ baustein.data.label }}
    </AppButton>
    <ElAlert
      v-else
      type="error"
      class="my-auto mx-auto"
      title="Es ist leider ein Fehler aufgetreten."
      show-icon
    />
  </div>
</template>
